import { inject, Pipe, PipeTransform } from '@angular/core';
import { StyleService } from '../services/style';

type StyleConverter = 'fontFormat' | 'border' | 'contour' | 'lineHeight' | 'shadow' | 'spacing' | 'spacing-horizontal';

@Pipe({
  name: 'responsiveStyle',
  standalone: true,
  pure: false,
})
export class ResponsiveStylePipe implements PipeTransform {
  private styleService = inject(StyleService);

  transform(value: any, mode: StyleConverter = 'fontFormat', prop?: string, unit: string = ''): any {
    // DNR: This functions gets triggered, when size Factor is changing
    const sizeFactor = this.styleService.sizeFactor();

    switch (mode) {
      case 'fontFormat':
        return this.styleService.convertFontFormat(value, prop, unit);
      case 'border':
        return this.styleService.convertBorder(value);
      case 'contour':
        return this.styleService.convertContour(value);
      case 'lineHeight':
        return this.styleService.convertLineHeight(value);
      case 'shadow':
        return this.styleService.convertShadow(value);
      case 'spacing':
        return this.styleService.convertSpacing(value);
      case 'spacing-horizontal':
        return this.styleService.getHorizontalSpacing(value);
    }
    return {};
  }
}
